// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media screen and (max-width: 765px) {\n.actions[data-v-1a01a657] {\n    margin-left: 2%;\n}\n}\n@media screen and (max-width: 870px) {\n.actions button[data-v-1a01a657] {\n    margin-bottom: 10px;\n}\n}", ""]);
// Exports
module.exports = exports;
